import { MessageBarType } from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import { DoorInstallationModel, IDoorInstallationModel } from '../../../../entities-generated/models/project/door-installation-model';
import { IStormDoorModel, StormDoorModel } from '../../../../entities-generated/models/storm-door/storm-door-model';
import { ShopStormDoorApiClient } from '../../../../services/shop-storm-door';
import { ToastService } from '../../../../framework/services/toast';
import { firstOrDefault } from '../../../../framework/utils/collection';
import { ProductDetailDialog } from '../pdct-detail-dialog';
import { ProductTexture } from '../../../../entities-generated/common/product-texture';

interface IStormDoorDetailDialogProps {
  info: { door: IDoorInstallationModel, site: string } | undefined;
  onChangeRequested: (door: IDoorInstallationModel, site: string) => void;
  onSeeInPersonRequested: () => void;
  onCloseDialog: () => void;
}

export const StormDoorDetailDialog: React.FunctionComponent<IStormDoorDetailDialogProps> = (props) => {
  const { info, onCloseDialog } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [door, setDoor] = useState<IStormDoorModel>(new StormDoorModel());

  useEffect(() => {
    if(info === undefined) { return; }

    setIsLoading(true);
    ShopStormDoorApiClient.getSelectedStormDoor(info.door.id)
    .then(resp => {
      const selectedVariant = firstOrDefault(resp.textureVariants, v => v.id === info.door.selectedDoor!.textureVariant.id) ?? resp.textureVariants[0];
      resp.textureVariants = [selectedVariant];
      setDoor(resp);
      setIsLoading(false);
    })
    .catch(() => {
      ToastService.show(MessageBarType.error, 'Sorry, we hit a snag - please try again');
      onCloseDialog();
    });
  }, [info, onCloseDialog]);

  const dim = info?.door ?? new DoorInstallationModel();
  return (
    <ProductDetailDialog
      id={door.id}
      brand={door.brand}
      title={`Storm Door - ${info?.site ?? ''}`}
      description={door.description}
      price={dim.selectedDoorPrice}
      averageRating={door.rating}
      rating={door.productReview}
      keyFeatures={door.sellingPoints}
      includedServices={dim.includedInPrice}
      variant={door.textureVariants[0] ?? new ProductTexture()}
      variantDescriptor={'color'}
      priceChange={dim.priceChange}
      onChangeSelection={() => props.onChangeRequested(dim, info?.site ?? '')}
      imageUrls={door.imageUrls}
      showDialog={!!info}
      isLoading={isLoading}
      onCloseDialog={props.onCloseDialog}
      onSeeInPersonRequested={props.onSeeInPersonRequested}
    />
  );
};
